<script setup lang="ts">
import type { CmsBlockTextTwoColumn } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockTextTwoColumn;
  class: any;
  style: any;
}>();

const { getSlotContent } = useCmsBlock(props.content);

const leftContent = getSlotContent("left");
const rightContent = getSlotContent("right");

</script>

<template>
  <section class="section section-main section-about section-about--alt section--solid" :style="props.style" :class="props.class">
    <div class="container">
      <div class="section__body">
        <div class="section__content section__content--alt">
          <div class="row">
            <div class="col-12 col-md-6" v-html="leftContent?.config?.content?.value ?? ''" />
            <div class="col-12 col-md-6" v-html="rightContent?.config?.content?.value ?? ''" />
          </div>
        </div><!-- /.section__content -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>
